// extracted by mini-css-extract-plugin
export default {"CreateSkill":"create-skill_CreateSkill__0SIao"};